<template>
    <div id="container-pie-radius">
        <v-chart :options="option" :initOptions="initOptions" :autoresize="true" ref='my'/>
    </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'zrender/lib/svg/svg'

export default {
  name: 'radiusPieChart',
  inject:['root'],
  props: {
      data:Object
  },
  data () {
    return {
        initOptions: {renderer: 'svg'},
        option:{},
        datas:{}
    }
  },
  watch: {
        data:{
            handler(){  
              this.init()
            },
            deep:false
        }
  },
  methods: {
    fontSize(res){
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = (clientWidth / 1920);
        return res*fontSize;
    },
    init(){
    let arr = [{value: this.data.ygh, name: '员购会',itemStyle:{color:'#16CEB9'}},
                {value: this.data.tmall, name: '天猫',itemStyle:{color:'#3F4357'}},
                {value: this.data.mall, name: '微商城',itemStyle:{color:'#16CEB9'}},
                {value: this.data.southwest, name: '西南区',itemStyle:{color:'#F7517F'}},
                {value: this.data.northern, name: '华北区',itemStyle:{color:'#4346D3'}},
                {value: this.data.eastern, name: '华东区',itemStyle:{color:'#02B5F8'}},
                {value: this.data.southern, name: '华南区',itemStyle:{color:'#6648FF'}},]
           
                  this.option = {
        legend: {
            orient: 'vertical',
            top: "20%",
            right: 10,
            itemWidth: 6,
            itemHeight: 6,
            textStyle:{
                color:'#FFFFFF',
                fontSize: 13
            },
            data: ['员购会', '天猫','微商城','西南区','华北区','华东区','华南区']
        },
        series: [
             {
                
            name: '总计',
            type: 'pie',
            label:{
                color:'#FFFFFF',
                fontSize: 13,
                lineHeight: 18,
                formatter: '{c} \n {d}%'
            },
            datasetIndex:1,
            hoverAnimation: true,
           radius:this.root.device=='phone'?['0%', '55%']:['0%', '70%'],                
            left:-90,
            data: arr
            }
        ]
        }
                 var len=arr.length;
      var currentindex=0;
          this.timer=setInterval(()=>{   
                this.$nextTick(()=>{
                  
                    this.$refs.my.dispatchAction({
                        type: 'highlight',         
                        seriesIndex: 0,
                        dataIndex: currentindex                  
                    })
                  
                      this.$refs.my.dispatchAction({
                          type: 'downplay',
                          seriesIndex: 0,
                          dataIndex:currentindex==0? len-1:currentindex-1
                      });
                })
              currentindex==len-1? currentindex=0:currentindex++;
            },3000)
    },
    

  },
    beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
  mounted () {
    
  

  },
  components: {
      'v-chart': ECharts
  }
}
</script>
<style lang="scss" type="text/scss">

    #container-pie-radius{
        width: 100%;
        height: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }

</style>